import { setStorageItem } from '../../../utils/auth'

export default {
  SET_INFOR_POS(state, data) {
    if (typeof data != 'object') {
      const index = state.pos.findIndex(e => e.id === data)
      if (index > 0) {
        state.posId = state.pos[index - 1].id
      } else if (index == 0 && state.pos.length > 1) {
        state.posId = state.pos[index + 1].id
      }
      state.pos.splice(index, 1)
    } else
    if (state.pos == null) {
      state.pos = new Array
      state.posId = data.id
      state.pos.push(data)
    } else {
      const index = state.pos.findIndex((e) => (e.id === data.id))
      if (index != -1) {
        state.pos[index] = data
      } else {
        state.pos.push(data)
        state.posId = data.id
      }
    }
    setStorageItem('POS_ID', JSON.stringify(state.posId))
    setStorageItem('POS', JSON.stringify(state.pos))
  },

  SET_ID_POS(state, data) {
    state.posId = data
    setStorageItem('POS_ID', JSON.stringify(state.posId))
  },

  SET_SAVE_POS(state, data) {
    state.posSave = data
    setStorageItem('POS_SAVE', JSON.stringify(data))
  },

  SET_REMOVE_POS(state, index) {
    state.pos.splice(index, 1)
    setStorageItem('POS', JSON.stringify(state.pos))
  },

  SET_LOADING(state, data) {
    state.loading = data;
  },

  SET_PARAMS(state, data) {
    state.params = data;
  },

  SET_ITEM_POS(state, data) {
    state.itemPos = data
  },

  SET_CUSTOMER(state, data) {
    state.modalAddCustomer = data;
  }
  //V2
  
}
